export function testSequence(str: string): boolean {
  return /(012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|210|000|111|222|333|444|555|666|777|888|999)/.test(
    str
  );
}
